"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StatusIcon;
var _ = require(".");
var _jsxRuntime = require("react/jsx-runtime");
function StatusIcon({
  variant = 'circle',
  ...rest
}) {
  switch (variant) {
    case 'battery':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_.BatteryStatusIcon, {
        ...rest
      });
    case 'circle':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_.CircleStatusIcon, {
        ...rest
      });
    default:
      console.log('Missing variant');
      return null;
  }
}